export const sdkUrl =
  'https://raw.githubusercontent.com/Aicade/games-console/main/src/lib/braincadeSDK.js'
export const vfxUrl =
  'https://raw.githubusercontent.com/ks-braincade/braincadeSDK/main/src/vfxLibrary.js'
export const phaserUrl =
  'https://cdnjs.cloudflare.com/ajax/libs/phaser/3.80.1/phaser.min.js'
export const JoystickUrl =
  'https://cdn.jsdelivr.net/gh/rexrainbow/phaser3-rex-notes@master/dist/rexvirtualjoystickplugin.min.js'
export const ButtonUrl =
  'https://cdn.jsdelivr.net/gh/rexrainbow/phaser3-rex-notes@master/dist/rexbuttonplugin.min.js'

export const displayScreenConstants = {
  gameOver: 'GAME_OVER',
  mainMenu: 'MAIN_MENU',
  start: 'START',
  splash: 'SPLASH',
  game: 'GAME',
}

export const GAME_FETCH_DURATION = 40

export const discordLink = 'https://discord.gg/5WutWSMWXr'
